module.exports = __webpack_public_path__ + "static/media/River_Pines_of_Farmington_Bylaws.a33b0bf0.pdf";